var angular = require('angular');
var template = require('./twoColumnBarometer.pug');

angular.module("app.directives").directive('twoColumnBarometer', function() {
  return {
    restrict: 'E',
    scope: {
      leftColumn: "=",
      rightColumn: "=",
      divider: "=",
      style: "="
    },

    template: template,
    link: function(scope) {
      scope.lengthToFontSize = function(value){
        value = Math.round(value).toString();
        if(value.length < 5) return 0.9
        if(value.length < 7) return 0.8
        if(value.length < 9) return 0.7
        return 0.5;
      }

      scope.fontSize = function(){
        var l = scope.lengthToFontSize(scope.leftColumn)
        var r = scope.lengthToFontSize(scope.rightColumn)
        return l > r ? l + 'em' : r + 'em'
      }

      scope.includeText = scope.style == null;

    }
  }


});
